import Vue from "vue";
import VueI18n from "vue-i18n";
import zh_cn from "./zh_cn.json";
import en from "./en.json";
import tc from "./tc.json";
Vue.use(VueI18n);
console.log(navigator.language);
const i18n = new VueI18n({
	locale:
		process.env.VUE_APP_language == "zh-CN"
			? "zh_cn"
			: navigator.language.substr(0, 2) == "zh"
			? "tc"
			: "en", //语言标识 海外版
	// locale: navigator.language == "zh_CN", //语言标识
	messages: {
		zh_cn,
		en,
		tc,
	},
	fallbackLocale: "zh_cn", //如果在message中找不到相应的键值将回退到原本的语言
	formatFallbackMessages: true, //如果在message中找不到相应的键值将回退到原本的语言
});

export default i18n;
